<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <button type="button" class="ac-close-button" @click="close">
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
      <div class="ac-header ml-2">Import CSV</div>
    </div>
    <div class="ac-body-container">
      <form
        v-if="!fileName && !parsing"
        class="dropbox-form"
        enctype="multipart/form-data"
      >
        <div class="sac__font-18 semibold">
          Upload multiple entries at once with a .CSV file.
        </div>
        <div class="alert-banner">
          <img
            src="@shared/assets/img/general/i-blue-circle.svg"
            alt="x"
            class="icon-header"
          />
          <div class="sac__font-14 width-100">
            Please ensure the column headers consist of .
            <div class="flex-row">
              <ul class="flex-column width-50">
                <li class="width-50">First Name</li>
                <li class="width-50">Last Name</li>
                <li class="width-50">Email</li>
                <li class="width-50">Phone Number</li>
              </ul>
              <ul class="flex-column width-50">
                <li class="width-50">Address1</li>
                <li class="width-50">Address2</li>
                <li class="width-50">City</li>
                <li class="width-50">State</li>
                <li class="width-50">Postal Code</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="dropbox-container">
          <input
            id="cust-import"
            ref="profile"
            type="file"
            aria-label="upload"
            class="db-input"
            @change="selectedFile"
          />
          <img
            class="spreadsheet"
            src="@shared/assets/img/technician/spreadsheet.png"
            alt="Spreadsheet"
          />
          <div class="sac__font-16">Add file</div>
        </div>
      </form>
      <div v-else-if="parsing" class="processing-container">
        <div class="p-container">
          <img
            src="@shared/assets/img/technician/uploading.png"
            alt="Spreadsheet"
          />
          <div class="p-sub-item">
            <span>{{ fileName }}</span>
            <div class="p-sub-container">
              <span>Uploading</span>
              <img
                src="@shared/assets/img/general/loading.svg"
                alt="processing"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="parsingErrorObj.uploadErrorArr" class="error-container">
        <div
          v-for="error in parsingErrorObj.uploadErrorArr"
          :key="error"
          class="error-text"
        >
          {{ error }}
        </div>
      </div>
      <div>
        <button type="button" class="f-button" @click="generateAndDownloadCSV">
          Download an example CSV template
        </button>
      </div>
    </div>
    <div class="ac-footer-container">
      <button type="button" class="ac-form-button" @click="close">Cancel</button>
      <button type="button" class="ac-form-button" @click="uploadFile">
        Upload
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import customerMixin from '@shared/mixins/customerMixin';

export default {
  name: 'InviteCsvMember',
  components: {
    ProcessOverlay,
  },
  mixins: [customerMixin],
  data() {
    return {
      fileName: '',
      errorObj: {},
      parsing: false,
      processing: false,
    };
  },
  methods: {
    close() {
      this.$store.dispatch('changeCustomerValues', [
        {
          field: 'showActionModal',
          value: false,
        },
      ]);
    },
    generateAndDownloadCSV() {
      try {
        const csvData = [
          [
            'firstName',
            'lastName',
            'email',
            'phone',
            'address1',
            'address2',
            'city',
            'state',
            'postalCode',
            'country',
          ],
          [
            'John',
            'Smith',
            'john.smith@example.com',
            '888-888-8888',
            '5302 Egbert St',
            '',
            'Houston',
            'TX',
            '77009',
            'US',
          ],
        ];

        const csvContent = csvData.map((row) => row.join(',')).join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const blobURL = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobURL;
        link.download = 'member_template.csv';

        link.click();

        URL.revokeObjectURL(blobURL);
      } catch (error) {
        console.error('Error generating or downloading CSV:', error);
      }
    },
    uploadFile() {
      const el = document.getElementById('cust-import');
      if (el) {
        el.click();
      }
    },
    async selectedFile() {
      this.parsing = true;
      const file = this.$refs.profile.files[0];
      this.fileName = file.name;
      const reader = new FileReader();
      await new Promise((resolve) => {
        setTimeout(resolve, 2000);
      });
      reader.onload = async (e) => {
        await this.$store.dispatch('parseMemberUpload', e.target.result);
        this.parsing = false;
      };
      reader.readAsText(file);
    },
  },
};
</script>

<style lang="scss">
.ac-app-container {
  width: 54px;
  height: 54px;
  background-color: $N100;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 80%;
  }
}

.step-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  .step-indicator {
    width: 82px;
    height: 16px;
    background-color: $N20;
    &.active {
      background-color: $NBLUE100;
    }
    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:nth-child(2) {
      margin-left: 4px;
      margin-right: 4px;
    }
    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
}
.error-text {
  font-weight: 500;
  color: $TOMATO100;
}
.processing-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 50%;

  .p-container {
    display: flex;
    align-items: center;
    padding: 40px;

    .p-sub-item {
      padding: 10px;

      span {
        padding: 10px;
      }
    }

    .p-sub-container {
      display: flex;
      align-items: center;
      gap: 10px;
      height: 35px;

      span {
        letter-spacing: 0;
        line-height: 24px;
        white-space: nowrap;
        color: #979797;
        padding: 10px;
      }

      img {
        width: 25px;
      }
    }

    img {
      height: 96px;
      width: 77px;
    }
  }

  .p-spinner {
    width: 30px;
    margin-bottom: 12px;
    margin-top: 12px;
  }

  .p-header {
    font-size: 2rem;
    font-weight: 500;
  }
}
</style>
